import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import loadTraits from './traits';
import { colDataGroupRef } from './consts';

export default grapesjs.plugins.add('gjs-data-group-external-api', (editor, opts) => {
  let options = opts || {};

  let defaults = {
    pfx: 'data-group-external-api',
    blocks: [colDataGroupRef],
    defaultStyle: true,
    labelTable: 'Data Group External API',
    labelCMSCategory: 'CMS',
  };

  for (let name in defaults) {
    if (!(name in options)) options[name] = defaults[name];
  }
  loadTraits(editor, options);
  loadComponents(editor, options);
  loadBlocks(editor, options);
});
